import { Action } from 'infra/types'
import { FILTER_OPTION } from 'services/Api/types'
import {
  IFilterByLabelKeyPayload,
  IKeyLabelFilterPayload,
  ITagFilterState
} from 'state/new-summary/root-drawers/tag-filter/tag-filter.types'

export const tagFilterDrawerActions = {
  SET_TAG_FILTER_DRAWER: 'tagFilterDrawer/setTagFilterDrawer',
  SET_SELECTED_TAGS_DATA: 'tagFilterDrawer/setSelectedTagsData',
  RESET_TAG_FILTER: 'tagFilterDrawer/resetTagFilter',
  SET_KEY_LABEL_FILTER_DATA: 'tagFilterDrawer/SET_KEY_LABEL_FILTER_DATA',
  SET_ALL_FILTER_DRAWER: 'tagFilterDrawer/SET_ALL_FILTER_DRAWER',
  FILTER_ENTITY_BY_LABEL_KEY_VALS: 'tagFilterDrawer/FILTER_ENTITY_BY_LABEL_KEY_VALS'
}

export const setTagFilterDrawer = (payload: {
  drawerStatus: boolean
}): Action<{
  drawerStatus: boolean
}> => {
  return {
    type: tagFilterDrawerActions.SET_TAG_FILTER_DRAWER,
    payload
  }
}

export const resetTagFilterState = () => {
  return {
    type: tagFilterDrawerActions.RESET_TAG_FILTER
  }
}

export const setSelectedTagsDataAndButtonType = (payload: {
  selectedTagsFilter: string[]
  selectedTagsFilterType: FILTER_OPTION
  buttonType?: 'save_and_apply' | 'apply'
  drawerStatus?: boolean
  showSave?: boolean
}): Action<{
  selectedTagsFilter: string[]
  selectedTagsFilterType: FILTER_OPTION
  buttonType?: 'save_and_apply' | 'apply'
  drawerStatus?: boolean
  showSave?: boolean
}> => {
  return {
    type: tagFilterDrawerActions.SET_SELECTED_TAGS_DATA,
    payload
  }
}

export const setSelectedKeysFilterData = (
  payload: IKeyLabelFilterPayload
): Action<IKeyLabelFilterPayload> => ({
  type: tagFilterDrawerActions.SET_KEY_LABEL_FILTER_DATA,
  payload
})

export const setAllTagLabelFilterDrawer = (payload: {
  id: keyof ITagFilterState['drawers']
  value: boolean
}): Action<{
  id: string
  value: boolean
}> => ({
  type: tagFilterDrawerActions.SET_ALL_FILTER_DRAWER,
  payload
})

export const setFilterEntityByLabelKeyVals = (
  payload: IFilterByLabelKeyPayload
): Action<IFilterByLabelKeyPayload> => ({
  type: tagFilterDrawerActions.FILTER_ENTITY_BY_LABEL_KEY_VALS,
  payload
})
